import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

export interface OrderPrincipalCardDetailsLoadingProps {
  isMobile?: boolean;
  isBasket: boolean;
}

export const OrderPrincipalCardDetailsLoading: React.FC<OrderPrincipalCardDetailsLoadingProps> = ({
  isMobile,
  isBasket,
}) => {
  const renderInfo = (title: string) => (
    <Stack
      space={Spacing['stack.quarck']}
      direction={isMobile ? 'row' : 'column'}
      justifyContent={isMobile ? 'space-between' : 'inherit'}>
      <UI.Text variant="semibold" color={isMobile ? 'neutral.medium' : 'neutral.darkest'}>
        {title}
      </UI.Text>
      <UI.Text color="neutral.black" isLoading w="35px" />
    </Stack>
  );

  if (isMobile) {
    return (
      <VStack
        p={Spacing['inset.sm']}
        space={Spacing['stack.nano']}
        bgColor={Utils.ColorToken.WithOpacity('brand.primary.lightest', 0.3)}
        borderRadius={BoxBorder.heavy}>
        <HStack justifyContent="space-between">
          <HStack space={Spacing['inline.xxxs']}>
            <UI.Text h={Typography['fontsize.md']} isLoading w="50px" />
          </HStack>
          <UI.IconButton
            testId="pdf-export"
            p={0}
            icon="Pdf"
            iconSize="xxs"
            iconColor={Color['brand.tertiary.principal']}
            disabled
            isDisabled
          />
        </HStack>
        {renderInfo('Nome da ordem')}
        {!!isBasket && renderInfo('Clientes')}
        {!!isBasket && renderInfo('Ativos')}
        {renderInfo('Valor enviado')}
        {renderInfo('Data de envio')}
        {renderInfo('Canal de envio')}
      </VStack>
    );
  }

  return (
    <HStack
      p={Spacing['inset.xs']}
      bgColor={Utils.ColorToken.WithOpacity('brand.primary.lightest', 0.3)}
      borderRadius={BoxBorder.heavy}
      justifyContent="space-between">
      {renderInfo('Nome da ordem')}
      <Stack />
      {isBasket ? renderInfo('Clientes') : <Stack />}
      {isBasket ? renderInfo('Ativos') : <Stack />}
      {renderInfo('Valor enviado')}
      {renderInfo('Data de envio')}
      {renderInfo('Canal de envio')}
    </HStack>
  );
};
